// extracted by mini-css-extract-plugin
export default {"container":"CashApp_container__cCx1u","h4":"CashApp_h4__Qjk+p","PaymentType":"CashApp_PaymentType__ueepR"};